// extracted by mini-css-extract-plugin
export default {"text_header":"common_text_header__9o7Yf"};